import { callApi } from 'utils/api';

export * from '../members/state/auth/api';
export * from '../members/state/user/api';
export * from '../members/state/mail/api';
export * from '../members/state/chat/api';
export * from '../members/state/magazine/api';
export * from '../members/state/categories/api';
export * from '../members/state/topics/api';
export * from '../members/state/goals/api';
export * from '../members/state/journal/api';
export * from '../members/state/feedback/api';
export * from '../members/state/comments/api';
export * from '../members/state/f2f/api';
export * from '../members/state/feed/api';
export * from '../members/state/search/api';
export * from '../members/state/links/api';
export * from '../members/state/forum/api';
export * from '../members/state/localAuthorities/api';

export function homePageFetch() {
 return callApi('/homepage')
 .then(json => {
   return json.articles;
 });
}

export function teamMembersFetch(options = { online: 'all', sort: 'alphabetical_asc' }) {
  return callApi('/more/meet-the-team', {
    query: {
      online: options.online,
      sort: options.sort,
      limit: 1000,
      offset: 0
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/__shared__/api.js
 **/